import React, { useEffect, useState } from "react";
import Modal from "../../elements/front/Modal";
import Textarea from "../../form/front/Textarea";
import Button from "../../form/front/Button";

const StartChatModal = ({
  isOpen = false,
  onClose = () => {},
  title = "Send a message",
  subtitle,
  placeholder = "Write a message…",
  defaultValue = "",
  isSending = false,
  onSend = async (_content) => {},
}) => {
  const [content, setContent] = useState(defaultValue || "");

  useEffect(() => {
    if (isOpen) setContent(defaultValue || "");
  }, [isOpen, defaultValue]);

  const canSend = content.trim().length > 0 && !isSending;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      size="md"
      bodyClasses="!pt-3"
      modalFooter={() => (
        <div className="flex items-center justify-end gap-2 px-3 pb-3 md:px-6 md:pb-6">
          <Button
            buttonLabel="Cancel"
            buttonClasses="bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"
            buttonFunction={onClose}
            isDisable={isSending}
          />
          <Button
            buttonLabel={isSending ? "Sending..." : "Send"}
            buttonIcon="fa-solid fa-paper-plane"
            buttonClasses="bg-palatte text-white"
            buttonFunction={() => onSend(content)}
            isDisable={!canSend}
            loading={isSending}
          />
        </div>
      )}
    >
      <Textarea
        inputPlaceholder={placeholder}
        inputValue={content}
        onChange={(e) => setContent(e.target.value)}
        inputClasses="h-28"
      />
    </Modal>
  );
};

export default StartChatModal;

